// import { useState } from "react";
// import './Nav.css'
// import { NavLink } from "react-router-dom";

// export default function Nav({ scrollToApply, logo }) {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const closeMenu = () => setMenuOpen(false);

//   const handleApplyClick = (e) => {
//     closeMenu();
//     // if (scrollToApply) scrollToApply(e);
//     // navigation.navigate('/for-providers#apply')
//   };

//   return (
//     <header className="wsh-nav" id="nav">
//       <div className="wsh-nav-inner">
//         <a href="/" className="wsh-nav-logo" aria-label="Washta" onClick={closeMenu}>
//           <img className="wsh-nav-wordmark" src={logo} alt="Washta" />
//         </a>
//         <nav className="wsh-nav-links">
//           <a href="/#how">How it works</a>
//           <a href="/for-providers">For providers</a>
//         </nav>
//         <div className="wsh-nav-cta">
//           <a href="#apply" onClick={scrollToApply} className="btn btn-primary btn-sm">
//             Apply to join
//           </a>

//           <a
//             href="https://apps.apple.com/us/app/washta/id6693265373"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="wsh-store-badge"
//             aria-label="Download on the App Store"
//           >
//             <svg viewBox="0 0 24 24" fill="currentColor">
//               <path d="M17.564 13.02c-.025-2.55 2.083-3.77 2.176-3.83-1.186-1.74-3.03-1.97-3.687-2-1.57-.16-3.06.92-3.86.92-.79 0-2.018-.9-3.32-.875-1.71.025-3.29 1-4.17 2.53-1.78 3.08-.456 7.64 1.276 10.14.847 1.22 1.857 2.6 3.18 2.55 1.276-.05 1.758-.825 3.3-.825 1.54 0 1.974.825 3.32.8 1.37-.025 2.24-1.25 3.08-2.48.97-1.42 1.37-2.8 1.39-2.87-.03-.013-2.668-1.025-2.695-4.06zM15.06 5.78c.7-.85 1.174-2.03 1.044-3.21-1.01.04-2.23.673-2.954 1.52-.65.75-1.22 1.95-1.067 3.1 1.127.088 2.277-.573 2.977-1.41z"></path>
//             </svg>
//             <span className="wsh-sb-txt">
//               <small>Download on the</small>
//               <b>App Store</b>
//             </span>
//           </a>

//           <a
//             href="https://play.google.com/store/apps/details?id=com.washta"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="wsh-store-badge"
//             aria-label="Get it on Google Play"
//           >
//             <svg viewBox="0 0 24 24">
//               <path fill="#34D399" d="M3.6 2.4c-.2.2-.3.5-.3.9v17.4c0 .4.1.7.3.9l9.2-9.6z"></path>
//               <path fill="#60A5FA" d="M16.8 8.3 12.8 12l4 3.7 3.1-1.8c.9-.5.9-1.9 0-2.4z"></path>
//               <path fill="#FBBF24" d="m12.8 12-9.2 9.6c.3.3.8.4 1.3.1l12-6.9z"></path>
//               <path fill="#F87171" d="M3.6 2.4 12.8 12l4-3.7-12-6.9c-.5-.3-1-.2-1.2.1z"></path>
//             </svg>
//             <span className="wsh-sb-txt">
//               <small>Get it on</small>
//               <b>Google Play</b>
//             </span>
//           </a>
//         </div>
//         <button
//           type="button"
//           className={`wsh-nav-burger ${menuOpen ? "is-open" : ""}`}
//           aria-label={menuOpen ? "Close menu" : "Open menu"}
//           aria-expanded={menuOpen}
//           aria-controls="wsh-nav-mobile-panel"
//           onClick={() => setMenuOpen((v) => !v)}
//         >
//           <span></span>
//           <span></span>
//           <span></span>
//         </button>
//       </div>
//       <div
//         id="wsh-nav-mobile-panel"
//         className={`wsh-nav-mobile ${menuOpen ? "is-open" : ""}`}
//         aria-hidden={!menuOpen}
//       >
//         <div className="wsh-nav-mobile-inner">
//           <nav className="wsh-nav-mobile-links">
//             <a href="/#how" onClick={closeMenu} style={{ "--i": 0 }} tabIndex={menuOpen ? 0 : -1}>
//               How it works
//             </a>
//             <a href="/for-providers" onClick={closeMenu} style={{ "--i": 1 }} tabIndex={menuOpen ? 0 : -1}>
//               For providers
//             </a>
//           </nav>

//           <div className="wsh-nav-mobile-bottom" style={{ "--i": 2 }}>
//             <NavLink
//               to="/for-providers#apply"
//               onClick={handleApplyClick}
//               className="wsh-nav-mobile-apply"
//               tabIndex={menuOpen ? 0 : -1}
//             >
//               Apply to join
//             </NavLink>

//             <div className="wsh-nav-mobile-stores">
//               <a
//                 href="https://apps.apple.com/us/app/washta/id6693265373"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="wsh-store-badge"
//                 aria-label="Download on the App Store"
//                 tabIndex={menuOpen ? 0 : -1}
//               >
//                 <svg viewBox="0 0 24 24" fill="currentColor">
//                   <path d="M17.564 13.02c-.025-2.55 2.083-3.77 2.176-3.83-1.186-1.74-3.03-1.97-3.687-2-1.57-.16-3.06.92-3.86.92-.79 0-2.018-.9-3.32-.875-1.71.025-3.29 1-4.17 2.53-1.78 3.08-.456 7.64 1.276 10.14.847 1.22 1.857 2.6 3.18 2.55 1.276-.05 1.758-.825 3.3-.825 1.54 0 1.974.825 3.32.8 1.37-.025 2.24-1.25 3.08-2.48.97-1.42 1.37-2.8 1.39-2.87-.03-.013-2.668-1.025-2.695-4.06zM15.06 5.78c.7-.85 1.174-2.03 1.044-3.21-1.01.04-2.23.673-2.954 1.52-.65.75-1.22 1.95-1.067 3.1 1.127.088 2.277-.573 2.977-1.41z"></path>
//                 </svg>
//                 <span className="wsh-sb-txt">
//                   <small>Download on the</small>
//                   <b>App Store</b>
//                 </span>
//               </a>

//               <a
//                 href="https://play.google.com/store/apps/details?id=com.washta"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="wsh-store-badge"
//                 aria-label="Get it on Google Play"
//                 tabIndex={menuOpen ? 0 : -1}
//               >
//                 <svg viewBox="0 0 24 24">
//                   <path fill="#34D399" d="M3.6 2.4c-.2.2-.3.5-.3.9v17.4c0 .4.1.7.3.9l9.2-9.6z"></path>
//                   <path fill="#60A5FA" d="M16.8 8.3 12.8 12l4 3.7 3.1-1.8c.9-.5.9-1.9 0-2.4z"></path>
//                   <path fill="#FBBF24" d="m12.8 12-9.2 9.6c.3.3.8.4 1.3.1l12-6.9z"></path>
//                   <path fill="#F87171" d="M3.6 2.4 12.8 12l4-3.7-12-6.9c-.5-.3-1-.2-1.2.1z"></path>
//                 </svg>
//                 <span className="wsh-sb-txt">
//                   <small>Get it on</small>
//                   <b>Google Play</b>
//                 </span>
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// }
import { useState } from "react";
import './Nav.css'
import { NavLink } from "react-router-dom";

export default function Nav({ scrollToApply, logo }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  const handleApplyClick = (e) => {
    closeMenu();
  };

  return (
    <header className="wsh-nav" id="nav">
      <div className="wsh-nav-inner">
        <a href="/" className="wsh-nav-logo" aria-label="Washta" onClick={closeMenu}>
          <img className="wsh-nav-wordmark" src={logo} alt="Washta" />
        </a>
        <nav className="wsh-nav-links">
          <a href="/#how">How it works</a>
          <a href="/for-providers">For providers</a>
        </nav>
        <div className="wsh-nav-cta">
          <a href="#apply" onClick={scrollToApply} className="btn btn-primary btn-sm">
            Apply to join
          </a>

          <a
            href="https://apps.apple.com/us/app/washta/id6693265373"
            target="_blank"
            rel="noopener noreferrer"
            className="wsh-store-badge"
            aria-label="Download on the App Store"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.564 13.02c-.025-2.55 2.083-3.77 2.176-3.83-1.186-1.74-3.03-1.97-3.687-2-1.57-.16-3.06.92-3.86.92-.79 0-2.018-.9-3.32-.875-1.71.025-3.29 1-4.17 2.53-1.78 3.08-.456 7.64 1.276 10.14.847 1.22 1.857 2.6 3.18 2.55 1.276-.05 1.758-.825 3.3-.825 1.54 0 1.974.825 3.32.8 1.37-.025 2.24-1.25 3.08-2.48.97-1.42 1.37-2.8 1.39-2.87-.03-.013-2.668-1.025-2.695-4.06zM15.06 5.78c.7-.85 1.174-2.03 1.044-3.21-1.01.04-2.23.673-2.954 1.52-.65.75-1.22 1.95-1.067 3.1 1.127.088 2.277-.573 2.977-1.41z"></path>
            </svg>
            <span className="wsh-sb-txt">
              <small>Download on the</small>
              <b>App Store</b>
            </span>
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.washta"
            target="_blank"
            rel="noopener noreferrer"
            className="wsh-store-badge"
            aria-label="Get it on Google Play"
          >
            <svg viewBox="0 0 24 24">
              <path fill="#34D399" d="M3.6 2.4c-.2.2-.3.5-.3.9v17.4c0 .4.1.7.3.9l9.2-9.6z"></path>
              <path fill="#60A5FA" d="M16.8 8.3 12.8 12l4 3.7 3.1-1.8c.9-.5.9-1.9 0-2.4z"></path>
              <path fill="#FBBF24" d="m12.8 12-9.2 9.6c.3.3.8.4 1.3.1l12-6.9z"></path>
              <path fill="#F87171" d="M3.6 2.4 12.8 12l4-3.7-12-6.9c-.5-.3-1-.2-1.2.1z"></path>
            </svg>
            <span className="wsh-sb-txt">
              <small>Get it on</small>
              <b>Google Play</b>
            </span>
          </a>
        </div>
        <div className="wsh-nav-top-actions" aria-label="Store links">
          <a
            href="https://apps.apple.com/us/app/washta/id6693265373"
            target="_blank"
            rel="noopener noreferrer"
            className="wsh-store-icon"
            aria-label="Download on the App Store"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.564 13.02c-.025-2.55 2.083-3.77 2.176-3.83-1.186-1.74-3.03-1.97-3.687-2-1.57-.16-3.06.92-3.86.92-.79 0-2.018-.9-3.32-.875-1.71.025-3.29 1-4.17 2.53-1.78 3.08-.456 7.64 1.276 10.14.847 1.22 1.857 2.6 3.18 2.55 1.276-.05 1.758-.825 3.3-.825 1.54 0 1.974.825 3.32.8 1.37-.025 2.24-1.25 3.08-2.48.97-1.42 1.37-2.8 1.39-2.87-.03-.013-2.668-1.025-2.695-4.06zM15.06 5.78c.7-.85 1.174-2.03 1.044-3.21-1.01.04-2.23.673-2.954 1.52-.65.75-1.22 1.95-1.067 3.1 1.127.088 2.277-.573 2.977-1.41z"></path>
            </svg>
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.washta"
            target="_blank"
            rel="noopener noreferrer"
            className="wsh-store-icon"
            aria-label="Get it on Google Play"
          >
            <svg viewBox="0 0 24 24">
              <path fill="#34D399" d="M3.6 2.4c-.2.2-.3.5-.3.9v17.4c0 .4.1.7.3.9l9.2-9.6z"></path>
              <path fill="#60A5FA" d="M16.8 8.3 12.8 12l4 3.7 3.1-1.8c.9-.5.9-1.9 0-2.4z"></path>
              <path fill="#FBBF24" d="m12.8 12-9.2 9.6c.3.3.8.4 1.3.1l12-6.9z"></path>
              <path fill="#F87171" d="M3.6 2.4 12.8 12l4-3.7-12-6.9c-.5-.3-1-.2-1.2.1z"></path>
            </svg>
          </a>
        </div>
        <button
          type="button"
          className={`wsh-nav-burger ${menuOpen ? "is-open" : ""}`}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          aria-controls="wsh-nav-mobile-panel"
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <div
        id="wsh-nav-mobile-panel"
        className={`wsh-nav-mobile ${menuOpen ? "is-open" : ""}`}
        aria-hidden={!menuOpen}
      >
        <div className="wsh-nav-mobile-inner">
          <nav className="wsh-nav-mobile-links">
            <a href="/#how" onClick={closeMenu} style={{ "--i": 0 }} tabIndex={menuOpen ? 0 : -1}>
              How it works
            </a>
            <a href="/for-providers" onClick={closeMenu} style={{ "--i": 1 }} tabIndex={menuOpen ? 0 : -1}>
              For providers
            </a>
          </nav>

          <div className="wsh-nav-mobile-bottom" style={{ "--i": 2 }}>
            <NavLink
              to="/for-providers#apply"
              onClick={handleApplyClick}
              className="wsh-nav-mobile-apply "
              tabIndex={menuOpen ? 0 : -1}
            >
              Apply to join
            </NavLink>

          </div>
        </div>
      </div>
    </header>
  );
}